<template>
  <div class="summary">
    <Loading/>
    <div v-if="getProduct && getProduct.variation">
      <div v-for="step in getSteps" class="step" v-if="step.id !== 'pa_additionals'">
        <span class="name">{{ step.name }}</span>
        <div class="option">
          <div class="value" @click="openStepEdit(step.id)">
            <span class="values">{{ parseValue(step.id) }}</span>
            <span class="action">
                Zmień
            </span>
          </div>
          <div class="price-diff" v-if="step.id === 'pa_tkanina' && getProduct.variation.price_diff">
            {{ getProduct.variation.price_diff | price }}
          </div>
        </div>

      </div>

      <div class="step" v-if="getComplementaryNames">
        <span class="name">Poduszki</span>
        <div class="option">
          <div class="value no-editable">{{ getComplementaryNames }}</div>
          <div class="price-diff">
            0 zł
          </div>
        </div>
      </div>

      <template v-if="getAdditionStep">
        <div class="additional-text"><span>Dodatkowo do koszyka trafią</span></div>

        <div class="step">
          <span class="name">{{ getAdditionStep.name }}</span>
          <div class="option">
            <div class="value" @click="openStepEdit(getAdditionStep.id)">
              <span class="values">{{ parseValue(getAdditionStep.id) }}</span>
              <span class="action">
                Zmień
              </span>
            </div>
            <div class="price-diff" v-if="getAdditionPrice">
              {{ getAdditionPrice | price }}
            </div>
          </div>

        </div>

      </template>

      <div class="customizer-reset">
        Chcesz zacząć od początku? <span class="link-action" @click="initResetCustomizer">Resetuj ustawienia</span>
      </div>
    </div>
    <div class="open-customizer" v-else>
      <div class="item">
        <button class="btn-create" @click="openCustomizer" :disabled="!getVariationsCount">
          {{ getVariationsCount ? 'Dobierz kolor i tkaninę Twojego mebla' : 'Ładuję konfigurator' }}
        </button>
        <div class="customizer-count" v-if="getVariationsCount">
          Mamy {{ getProduct.product.variations }} dostępnych konfiguracji
        </div>
      </div>
      <div class="item" v-if="getDefaultVariation">
        <button class="btn-create outlined" :class="{ opened: openOptions }" @click="getDefaultVariation.custom_arrangement ? openOptions = !openOptions : quickAddToCart()">
          Wybieram tkaninę ze zdjęcia
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none" v-if="getDefaultVariation.custom_arrangement">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.0002 1.88257C18.0002 2.13857 17.9023 2.39457 17.7073 2.58957L9.70725 10.5896C9.31625 10.9806 8.68425 10.9806 8.29325 10.5896L0.29325 2.58957C-0.09775 2.19857 -0.09775 1.56657 0.29325 1.17557C0.68425 0.784574 1.31625 0.784574 1.70725 1.17557L9.00025 8.46857L16.2932 1.17557C16.6842 0.784574 17.3162 0.784574 17.7073 1.17557C17.9023 1.37057 18.0002 1.62657 18.0002 1.88257Z" fill="#3C3C3C"/>
          </svg>
        </button>
        <transition name="fade">
        <ul class="options" v-if="openOptions && getDefaultVariation.custom_arrangement && getDefaultVariation.custom_arrangement">
          <li v-for="(option, index) in getDefaultVariation.custom_arrangement" :key="option.id" @click="quickAddToCart(option.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none" v-if="index === 0">
              <mask id="path-1-inside-1_6396_93565" fill="white">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.41176 0C0.632069 0 0 0.63207 0 1.41177V13.067C0 13.0716 2.17766e-05 13.0762 6.52317e-05 13.0807L6.48456e-05 21.9152C6.48115e-05 22.6949 0.632134 23.327 1.41183 23.327H13.0671C13.8468 23.327 14.4789 22.6949 14.4789 21.9152V14.4788H33.1765C33.9562 14.4788 34.5882 13.8467 34.5882 13.067V1.41177C34.5882 0.632069 33.9562 0 33.1765 0H13.0671H1.41183H1.41176Z"/>
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.41176 0C0.632069 0 0 0.63207 0 1.41177V13.067C0 13.0716 2.17766e-05 13.0762 6.52317e-05 13.0807L6.48456e-05 21.9152C6.48115e-05 22.6949 0.632134 23.327 1.41183 23.327H13.0671C13.8468 23.327 14.4789 22.6949 14.4789 21.9152V14.4788H33.1765C33.9562 14.4788 34.5882 13.8467 34.5882 13.067V1.41177C34.5882 0.632069 33.9562 0 33.1765 0H13.0671H1.41183H1.41176Z" fill="white"/>
              <path d="M6.52317e-05 13.0807H1.41189L1.41177 13.0673L6.52317e-05 13.0807ZM6.48456e-05 21.9152H-1.4117H6.48456e-05ZM14.4789 14.4788V13.067C13.6992 13.067 13.0671 13.6991 13.0671 14.4788H14.4789ZM1.41176 1.41177V1.41176V-1.41176C-0.14763 -1.41176 -1.41176 -0.147624 -1.41176 1.41177H1.41176ZM1.41176 13.067V1.41177H-1.41176V13.067H1.41176ZM1.41177 13.0673C1.41177 13.0672 1.41176 13.0671 1.41176 13.067H-1.41176C-1.41176 13.0761 -1.41172 13.0851 -1.41164 13.0942L1.41177 13.0673ZM1.41183 21.9152L1.41183 13.0807H-1.4117L-1.4117 21.9152H1.41183ZM1.41183 21.9152H1.41183H-1.4117C-1.4117 23.4746 -0.14756 24.7387 1.41183 24.7387V21.9152ZM13.0671 21.9152H1.41183V24.7387H13.0671V21.9152ZM13.0671 21.9152V21.9152V24.7387C14.6265 24.7387 15.8906 23.4746 15.8906 21.9152H13.0671ZM13.0671 14.4788V21.9152H15.8906V14.4788H13.0671ZM33.1765 13.067H14.4789V15.8906H33.1765V13.067ZM33.1765 13.067V13.067V15.8906C34.7359 15.8906 36 14.6264 36 13.067H33.1765ZM33.1765 1.41177V13.067H36V1.41177H33.1765ZM33.1765 1.41176V1.41177H36C36 -0.147627 34.7359 -1.41176 33.1765 -1.41176V1.41176ZM13.0671 1.41176H33.1765V-1.41176H13.0671V1.41176ZM1.41183 1.41176H13.0671V-1.41176H1.41183V1.41176ZM1.41176 1.41176H1.41183V-1.41176H1.41176V1.41176Z" fill="#3C3C3C" mask="url(#path-1-inside-1_6396_93565)"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="24" viewBox="0 0 35 24" fill="none" v-if="index === 1">
              <mask id="path-1-inside-1_6396_93574" fill="white">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M33.1761 0.336426C33.9558 0.336426 34.5879 0.968496 34.5879 1.74819V13.4035C34.5879 13.408 34.5879 13.4126 34.5878 13.4172L34.5878 22.2516C34.5878 23.0313 33.9558 23.6634 33.1761 23.6634H21.5208C20.7411 23.6634 20.109 23.0313 20.109 22.2516V14.8152H1.41142C0.631721 14.8152 -0.000347137 14.1832 -0.000347137 13.4035V1.74819C-0.000347137 0.968495 0.631721 0.336426 1.41142 0.336426H21.5208H33.1761H33.1761Z"/>
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M33.1761 0.336426C33.9558 0.336426 34.5879 0.968496 34.5879 1.74819V13.4035C34.5879 13.408 34.5879 13.4126 34.5878 13.4172L34.5878 22.2516C34.5878 23.0313 33.9558 23.6634 33.1761 23.6634H21.5208C20.7411 23.6634 20.109 23.0313 20.109 22.2516V14.8152H1.41142C0.631721 14.8152 -0.000347137 14.1832 -0.000347137 13.4035V1.74819C-0.000347137 0.968495 0.631721 0.336426 1.41142 0.336426H21.5208H33.1761H33.1761Z" fill="white"/>
              <path d="M34.5878 13.4172H33.176L33.1761 13.4037L34.5878 13.4172ZM34.5878 22.2516H35.9996H34.5878ZM20.109 14.8152V13.4035C20.8887 13.4035 21.5208 14.0355 21.5208 14.8152H20.109ZM33.1761 1.74819V1.74819V-1.07534C34.7355 -1.07534 35.9997 0.188802 35.9997 1.74819H33.1761ZM33.1761 13.4035V1.74819H35.9997V13.4035H33.1761ZM33.1761 13.4037C33.1761 13.4036 33.1761 13.4036 33.1761 13.4035H35.9997C35.9997 13.4125 35.9996 13.4216 35.9995 13.4306L33.1761 13.4037ZM33.1761 22.2516L33.1761 13.4172H35.9996L35.9996 22.2516H33.1761ZM33.1761 22.2516H33.1761H35.9996C35.9996 23.811 34.7355 25.0751 33.1761 25.0751V22.2516ZM21.5208 22.2516H33.1761V25.0751H21.5208V22.2516ZM21.5208 22.2516V22.2516V25.0751C19.9614 25.0751 18.6973 23.811 18.6973 22.2516H21.5208ZM21.5208 14.8152V22.2516H18.6973V14.8152H21.5208ZM1.41142 13.4035H20.109V16.227H1.41142V13.4035ZM1.41142 13.4035V13.4035V16.227C-0.147976 16.227 -1.41211 14.9628 -1.41211 13.4035H1.41142ZM1.41142 1.74819V13.4035H-1.41211V1.74819H1.41142ZM1.41142 1.74819V1.74819H-1.41211C-1.41211 0.188799 -0.147976 -1.07534 1.41142 -1.07534V1.74819ZM21.5208 1.74819H1.41142V-1.07534H21.5208V1.74819ZM33.1761 1.74819H21.5208V-1.07534H33.1761V1.74819ZM33.1761 1.74819H33.1761V-1.07534H33.1761V1.74819Z" fill="#3C3C3C" mask="url(#path-1-inside-1_6396_93574)"/>
            </svg>
            {{ option.name }}
          </li>
        </ul>
        </transition>
        <div class="customizer-label">Tkanina {{ getDefaultVariation.custom_fabric }} / {{ getDefaultVariation.custom_price | price }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import Loading from './misc/Loading'
export default {
  name: "Summary",
  components: { Loading },
  filters: {
    price(price) {
      return new Intl.NumberFormat('pl-PL', {style: 'currency', currency: 'PLN'}).format(price)
    }
  },
  data() {
    return {
      priceDiffs: null,
      openOptions: false
    }
  },
  mounted() {
    const button = document.querySelector('.woocommerce-variation-add-to-cart .single_add_to_cart_button')

    let that = this
    if (button) {
      button.disabled = true
      button.onclick = (e) => {
        e.preventDefault()
        that.addToCart(that.getProductIDs).then(() => {
          const addToCartBtn = document.querySelector('.single_add_to_cart_button.cloned')

          if (addToCartBtn) {
            addToCartBtn.remove()
          }

          button.innerHTML = 'Dodano do koszyka'
          button.classList.add('disabled')
          button.disabled = true

          this.resetCustomizer()
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      getProduct: 'customizer/getProduct',
      getOptions: 'customizer/getOptions',
      getAttributes: 'customizer/getAttributes',
      getProductData: 'customizer/getProductData',
      // getVariations: 'customizer/getVariations',
      getTotalPrice: 'customizer/getTotalPrice',
      getSteps: 'customizer/getSteps',
      getStep: 'customizer/getStep'
    }),
    isVariationValid () {
      return !!(this.getProduct && this.getProduct.variation)
    },
    getVariationsCount() {
      if (this.getProduct && this.getProduct.product) {
        return this.getProduct.product.variations
      }
      return null
    },
    getDefaultVariation () {
      if (this.getProduct && this.getProduct.product.default) {
        return this.getProduct.product.default
      }
      return false
    },
    getVariations() {
      if (this.getProduct && this.getProduct.variation) {
        return this.getProduct.variation
      }
      return false
    },
    getFabricData() {
      const attributes = JSON.parse(JSON.stringify(this.getAttributes.pa_tkanina))
      return attributes.find(fabric => fabric.id === this.getOptions.pa_tkanina)
    },
    getAdditionStep() {
      const step = this.getSteps.find(step => step.id === 'pa_additionals')
      return step || null
    },
    getAdditionNames() {
      const additions = this.getOptions.pa_additionals
      return additions.map((item) => {
        return item.quantity > 1 ? item.quantity + 'x ' + item.name : item.name
      })
    },
    getComplementaryNames() {
      const complementary = this.getProduct.product.complementary
      if(!complementary) {
        return;
      }
      const fabric = this.getFabricData ? this.getFabricData.name : ''
      const values = complementary.map(item => (item.quantity + 'x ' + item.name + ` (${fabric})`));
      return values.join(', ')

    },
    getAdditionPrice() {
      if (!this.getOptions.pa_additionals) {
        return
      }
      return this.getOptions.pa_additionals.reduce((a, b) => a + b.price * b.quantity, 0)
    },
    getLoading() {
      return this.$parent.getLoading
    },
    getProductIDs() {
      // if (this.getOptions.pa_additionals && this.getOptions.pa_additionals.length === 0) {
      //   return []
      // }

      let additionals = this.getOptions.pa_additionals ? this.getOptions.pa_additionals.map((item) => {
        return {
          product_id: item.parent,
          variation_id: item.is_variation ? item.id : null,
          quantity: item.quantity,
          price: item.price
        }
      }) : []
      const quantity = document.querySelector('input.qty')

      additionals.unshift({
        product_id: this.getProduct.product.id,
        variation_id: this.getProduct.variation ? this.getProduct.variation.id : null,
        quantity: quantity ? quantity.value : 1,
        custom_fabric: this.getOptions.custom_fabric || null,
        price: this.getProduct.variation ? this.getProduct.variation.price : 0
      })

      if (this.getOptions.pa_materac) {
        additionals.push({
          product_id: this.getOptions.pa_materac.id,
          variation_id: null,
          quantity: 1,
          price: this.getOptions.pa_materac.price
        })
      }

      return additionals || []

      // if (this.getProduct) {
      //   return {
      //     additionals: additionals,
      //     variation_id: this.getProduct.variation.id,
      //     product_id: this.getProduct.product.id,
      //     quantity: quantity.value || 1
      //   }
      // }
    },
    getProductsPrice() {
      if (!this.getOptions.pa_additionals && this.getProductData) {
        return this.getProductData.price
      }

      if (!this.getProductData || !this.getProductData.price) {
        return
      }

      return parseFloat(this.getProductData.price) + parseFloat(this.getOptions.pa_additionals.reduce((a, b) => a + b.price * b.quantity, 0))
    },
    getProductPrice () {
      return this.getProductData.price
    }
  },
  watch: {
    getProductsPrice(n) {
      if(!n) {
        return
      }

      this.addTotalPriceDOM()
    },
    getVariations(n) {
      if (n) {
        const button = document.querySelector('.single_add_to_cart_button')
        if (button) {
          button.disabled = false
        }
      }
    },
    isVariationValid(n) {
      const element = document.querySelector('.product-description-box')
      if(!element) {
        return
      }
      if (n) {
        element.classList.remove('empty-config')
      } else {
        element.classList.add('empty-config')
      }
    },
    'getProduct.variation' (n) {
      if (!n) {
        const cloned = document.querySelector('.single_add_to_cart_button.cloned')
        if (cloned) {
          cloned.remove()
        }
        return
      }
      let that = this
      const addToCartBtn = document.querySelector('.woocommerce-variation-add-to-cart .single_add_to_cart_button')

      if(!addToCartBtn) {F
        return;
      }

      let cloneAddToCartBtn = addToCartBtn.cloneNode(true)
      cloneAddToCartBtn.setAttribute('type', 'button')
      cloneAddToCartBtn.classList.remove(...cloneAddToCartBtn.classList)
      cloneAddToCartBtn.classList.add('single_add_to_cart_button')
      cloneAddToCartBtn.classList.add('button')
      cloneAddToCartBtn.classList.add('cloned')

      if (!document.querySelector('.single_add_to_cart_button.cloned')) {
        document.querySelector('.shipping-costs').after(cloneAddToCartBtn);
      }

      cloneAddToCartBtn.addEventListener('click', e => {
        e.preventDefault()
        that.addToCart(that.getProductIDs).then(() => {

          document.querySelector('.single_add_to_cart_button.cloned').remove()

          if (addToCartBtn) {
            addToCartBtn.innerHTML = 'Dodano do koszyka'
            addToCartBtn.classList.add('disabled')
            addToCartBtn.disabled = true
          }

          this.resetCustomizer()
          // this.handleAddToCart()
        })
      })

    }
  },
  methods: {
    ...mapMutations({
      setStep: 'customizer/setStep',
      setCustomizerOpen: 'customizer/setCustomizerOpen',
      setCustomizerEdit: 'customizer/setCustomizerEdit',
      setLoading: 'customizer/setLoading',
      resetOptions: 'customizer/resetOptions',
    }),
    ...mapActions({
      addToCart: 'customizer/addToCart',
      resetCustomizer: 'customizer/resetCustomizer',
      initResetCustomizer: 'customizer/initResetCustomizer'
    }),
    handleAddToCart() {
      const button = document.querySelector('.woocommerce-variation-add-to-cart .single_add_to_cart_button')

      let that = this
      if (button) {
        button.disabled = true
        button.innerHTML = 'Dodano do koszyka'
        button.classList.add('added')
        button.disabled = false
      }
    },
    openStepEdit(step) {
      const item = this.getSteps.find(steps => steps.id === step)
      this.setCustomizerEdit({...item, completed: true})
    },
    getPriceDiff(step) {
      if (step === 'pa_additionals') {
        return this.getAdditionPrice
      }
    },
    findPriceDiff() {

      const product = this.getVariations.product

      let steps = JSON.parse(JSON.stringify(this.getSteps))
      const priceDiff = []
      let options = JSON.parse(JSON.stringify(this.getOptions))

      const additional = steps.findIndex(step => step.id === 'pa_additionals')
      steps.splice(additional, 1)

      steps.forEach((item, index) => {
        const stepIndex = steps.findIndex(step => step.id === item.id)
        const stepsBefore = stepIndex === 0 ? [steps[0].id] : steps.slice(0, stepIndex + 1).map(item => item.id)
        let values = {}


        stepsBefore.forEach((key, item) => {
          if (options.hasOwnProperty(key)) {
            values[key] = options[key]
          }
        })

        const value = this.getVariations.variations.filter((item) => {
          for (const v in item.attributes) {
            if (values[v] && values[v] !== item.attributes[v]) {
              return false
            }
          }
          return true;
        })

        priceDiff.push({...value[0], step: item.id})
      })

      let prices = []
      priceDiff.forEach((item, index) => {
        const prev = index > 0 ? priceDiff[index - 1] : null
        if (prev) {
          prices[item.step] = {
            price: item.price,
            diff: Math.abs(item.price - prev.price)
          }
        } else {
          prices[item.step] = {price: item.price, diff: Math.abs(product.price - item.price)}
        }
      })

      return prices
    },
    capitalizeFirstLetter(string) {
      if (!string) {
        return string
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    parseValue(step) {
      if (step === 'pa_tkanina' && this.getOptions['pa_tkanina']) {
        const value = this.getAttributes[step].find(option => option.id === this.getOptions[step])
        const custom = this.getOptions.custom_fabric

        return custom ? `Z próbnika: ${custom}` : `${this.capitalizeFirstLetter(this.getOptions.group)}, ${value.name}`
      }

      if (step === 'pa_nogi' && this.getOptions['pa_nogi']) {
        const value = this.getAttributes[step].find(option => option.id === this.getOptions[step])

        return value.name
      }

      if (step === 'pa_pinezki_ozdobne' && this.getOptions['pa_pinezki_ozdobne']) {
        const value = this.getAttributes[step].find(option => option.id === this.getOptions[step])

        return value.name
      }

      if (step === 'pa_additionals') {
        return this.getAdditionNames.length > 0 ? this.getAdditionNames.join(', ') : 'Nie wybrano'
      }

      if (step === 'pa_pojemnik' && this.getOptions['pa_pojemnik']) {
        const value = this.getAttributes[step].find(option => option.id === this.getOptions[step])

        return value.name
      }

      if (step === 'pa_materac') {
        return this.getOptions[step] ? this.getOptions[step].name : 'Nie wybrano'
      }

      if (step === 'pa_uklad' && this.getOptions['pa_uklad']) {
        const value = this.getAttributes[step].find(option => option.id === this.getOptions[step])

        return value.name
      }

      return this.getOptions[step]
    },
    openCustomizer() {
      const element = document.querySelector("#customizer-container");
      if (element && element.getAttribute('data-product-url') && element.getAttribute('data-product-view') === 'archive') {
        this.setCustomizerOpen(false)
        window.location.href = element.getAttribute('data-product-url') + '?openCustomizer'
      } else {
        this.setCustomizerOpen(true)
      }
    },
    addTotalPriceDOM() {
      // if (!this.getVariations) {
      //   return
      // }


      const productPrice = document.querySelector('.summary  .price .product-price span.amount')
      if (productPrice) {
        productPrice.innerHTML = this.$options.filters.price(this.getProductPrice)
      }
      const creditPrice = document.getElementById('ca-raty')
      if (creditPrice) {
        setTimeout(() => {
          creditPrice.dataset.priceVariation = this.getProductPrice
          creditPrice.dataset.priceAdditionals = this.getAdditionPrice
        }, 1000)
      }
    },
    quickAddToCart(arrangement = null) {
      this.openOptions = false
      this.addToCart([{
        product_id: this.getProduct.product.id,
        variation_id: null,
        quantity: 1,
        price: this.getDefaultVariation.custom_price,
        custom_fabric: this.getDefaultVariation.custom_fabric,
        custom_arrangement: arrangement ? arrangement : this.getDefaultVariation.custom_arrangement,
        custom_product: true
      }])
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .loading {
    .spinner {
      margin-top: 0;
    }
  }
}
.summary {
  flex: 0 0 100%;

  .open-customizer {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 7px;
  }

  .btn-create {
    padding: 12px 32px;
    display: inline-flex;
    align-items: center;
    background: #74C7ED;
    color: #fff;
    border: 1px solid #74C7ED;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
    transition: all .2s;
    cursor: pointer;
    z-index: 1;
    white-space: nowrap;

    &:hover {
      background: #3C91B8;
      border: 1px solid #3C91B8;
    }

    &:disabled {
      background: #EFEFEF;
      color: #C8C8C8;
      border: 1px solid #EFEFEF;

      svg path {
        fill: #C8C8C8;
      }
    }

    @media (max-width: 768px) {
      padding: 12px 20px;
      width: 100%;
      justify-content: center;
    }

    svg {
      flex: 0 0 18px;
      width: 18px;
      height: auto;
      transition: all .2s;
      margin-right: 10px;

      path {
        fill: #fff;
      }
    }

    &.outlined {
      background: #fff;
      color: #3C3C3C;
      border: 1px solid var(--gray-300, #E6E6E6);
      &:hover {
        background: #fff;
        border-color: #3C3C3C;
      }

      @media (max-width: 480px) {
        margin-top: 10px;
      }

      svg {
        width: 16px;
        flex: 0 0 16px;
        margin: 0 0 0 10px;
        transition: all .2s;
        path {
          fill: var(--gray-700, #3C3C3C);
        }
      }
      &.opened {
        background: #fff;
        border-color: #3C3C3C;
        svg {
          transform: rotate(-180deg);
        }
      }
    }
  }

  .item {
    position: relative;
    @media (max-width: 480px) {
      width: 100%;
    }
  }

  ul.options {
    position: absolute;
    margin: 0;
    padding: 0;
    left: 0;
    right: 0;
    list-style: none;
    z-index: 1;
    background: #fff;
    border-top: 0;
    li {
      padding: 12px 32px;
      font-size: 16px;
      font-weight: 600;
      color: #3C3C3C;
      display: flex;
      align-items: center;
      transition: all .2s;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid var(--gray-300, #E6E6E6);
      margin-top: 2px;
      &:hover {
        background: #fff;
        border-color: #3c3c3c;
      }
      svg {
        margin-right: 10px;
      }
    }
  }

  .customizer-count {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #3C91B8;
    margin-top: 5px;
  }

  .customizer-label {
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #3C3C3C;
    margin-top: 5px;
  }

  .additional-text {
    position: relative;

    span {
      background: #EFEFEF;
      border-radius: 4px;
      padding: 8px 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #3C3C3C;
      margin: 30px 0;
      display: inline-block;
      position: relative;
      z-index: 1;
    }

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: #EFEFEF;
    }
  }

  .step {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;

    .name {
      font-weight: 600;
      margin-bottom: 5px;
      color: #3C3C3C;
    }

    .option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 440px;

      .value {
        width: 79%;
        display: flex;
        align-items: center;
        padding: 8px 15px;
        border: 1px solid #74C7ED;
        border-radius: 4px;
        cursor: pointer;
        color: #3C3C3C;

        &.no-editable {
          border-color: #EFEFEF;
          cursor: default;
        }

        .values {
          padding-right: 15px;
        }

        .action {
          margin-left: auto;
          font-weight: 600;
          color: #3C91B8;
        }
      }

      .price-diff {
        width: 19%;
        font-weight: 600;
        color: #3C91B8;
        text-align: left;
      }
    }
  }

  .customizer-reset {
    margin: 35px 0 0 0;
    color: #3c3c3c;
    .link-action {
      font-weight: 600;
      color: #3C91B8;
      margin: 0 0 0 5px;
      cursor: pointer;
    }
  }
}
</style>
